import type { ReactNode } from 'react';

export type ModuleTileTone = 'violet' | 'sky' | 'emerald' | 'orange' | 'slate' | 'rose' | 'amber';

const TONES: Record<ModuleTileTone, string> = {
  violet: 'from-violet-400 to-violet-600 shadow-violet-200',
  sky: 'from-sky-400 to-sky-600 shadow-sky-200',
  emerald: 'from-emerald-400 to-emerald-600 shadow-emerald-200',
  orange: 'from-orange-400 to-orange-600 shadow-orange-200',
  slate: 'from-slate-500 to-slate-700 shadow-slate-300',
  rose: 'from-rose-400 to-rose-600 shadow-rose-200',
  amber: 'from-amber-300 to-amber-500 shadow-amber-200',
};

interface ModuleTileProps {
  icon: ReactNode;
  label: string;
  tone: ModuleTileTone;
  onClick: () => void;
}

/** Tarjeta de módulo con el mismo estilo que el inicio del panel de comercios. */
const ModuleTile = ({ icon, label, tone, onClick }: ModuleTileProps) => (
  <li className='list-none'>
    <button
      type='button'
      onClick={onClick}
      title={label}
      className='group flex aspect-[4/3] w-[200px] cursor-pointer flex-col items-center justify-between overflow-hidden rounded-[5px] bg-white p-[25px] shadow-[0_4px_4px_rgba(0,0,0,0.1)] transition-all duration-[0.25s] hover:scale-105 hover:shadow-[0_14px_35px_rgba(15,23,42,0.12)] focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#FF7500] motion-reduce:transition-none motion-reduce:hover:scale-100'
    >
      <span
        aria-hidden='true'
        className={`mt-2 flex h-[82px] w-[82px] items-center justify-center rounded-2xl bg-gradient-to-br text-white shadow-lg transition-transform duration-300 group-hover:-rotate-3 group-hover:scale-105 motion-reduce:transition-none motion-reduce:group-hover:rotate-0 ${TONES[tone]}`}
      >
        {icon}
      </span>
      <span className='w-full truncate text-center text-base'>{label}</span>
    </button>
  </li>
);

export default ModuleTile;
